<template>
  <div class="foot-account">
    <div class="top-container">
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        class="demo-ruleForm"
        label-width="80px"
      >
        <div class="row">
          <el-form-item label="食堂：" prop="canteen" >
            <el-select
              v-model="ruleForm.canteen"
              placeholder="请选择"
              class="w200"
              clearable
            >
              <el-option
                v-for="item in canteenList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间：" prop="date">
            <el-date-picker
              v-model="ruleForm.date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              class="white w240"
              clearable>
            </el-date-picker>
          </el-form-item>
          <el-form-item class="btn">
            <el-button class="btn-gray" @click="resetForm('ruleForm')">重置</el-button>
            <el-button class="btn-blue" type="primary" @click="search">确认</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>

    <div class="container">
      <div class="table" v-if="tableData.length > 0">
        <el-table
          :data="tableData"
          show-summary
        >
          <el-table-column label="序号" width="80" prop="sort"></el-table-column>
          <el-table-column label="供应商" prop="supplierName"></el-table-column>
          <el-table-column
            v-for="(item, index) in tableTitleList"
            :key="index"
            :prop="item.prop"
            :label="item.lable"
            :min-width="item.width"
            show-overflow-tooltip
          />
          <el-table-column label="金额（元）" prop="subtotal" width="128"></el-table-column>
        </el-table>
      </div>

      <div class="foot" v-if="tableData.length > 0">
        <el-button class="btn-border-text-blue" type="primary" @click="goBack">返回</el-button>
        <el-button
          type="text"
          class="btn-blue"
          @click="confirmPrint"
          >确认打印</el-button
        >
      </div>
      
      <div class="nothing" v-if="tableData.length == 0">
        <div>
          <div>
            <img src="../../../../../assets/nothing.png">
          </div>
          <p>暂无数据</p>
        </div>
      </div>
    </div>

    <!-- 打印 -->
    <el-dialog class="printer-dialog" top="10vh" title="打印" :visible.sync="printerDialog" width="1040px">
      <div class="printer" id="printer">
        <div>
          <p class="printer-title">一周伙食采购报表</p>
          <div class="printer-message">
            <ul class="list">
              <li class="list-item">单位：{{ warehouseName }}</li>
              <li class="list-item">数据期间：{{ date }}</li>
              <li class="list-item">打印日期：{{ printDate }}</li>
              <li class="list-item">金额单位：元</li>
            </ul>
          </div>
          <div class="table">
            <el-table
            class="table-printer"
            :data="tableData"
            show-summary
             style="width:100%">
              <el-table-column label="序号" width="80" prop="sort"></el-table-column>
              <el-table-column label="供应商" prop="supplierName" width="220"></el-table-column>
              <el-table-column
                v-for="(item, index) in tableTitleList"
                :key="index"
                :prop="item.prop"
                :label="item.lable"
                :min-width="item.width"
                show-overflow-tooltip
              />
              <el-table-column label="金额（元）" prop="subtotal" width="128"></el-table-column>
            </el-table>
          </div>
          <div class="sign-container">
            <div class="sign-content">
              大/中队主管
              <span class="under-line"></span>
            </div>
            <div class="sign-content">验收人：
              <span class="under-line"></span>
            </div>
            <div class="sign-content">采购人：
              <span class="under-line"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <el-button class="btn-white" @click="closePrinterDialog">取消</el-button>
        <el-button class="btn-blue" v-print="'#printer'">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { config } from '@/common/js/config.js'
import { formatTimeToDate, calculationDays } from "@/common/js/utils.js"
import Canteen from "@/models/canteen.js";
import Purchase from "@/models/purchase.js"
export default {

  data() {
    return {
      ruleForm: {
        canteen: '',
        date: '',
      },
      canteenList: [],
      tableData: [],
      tableTitleList: [],
      printerDialog: false,
      warehouseName: '',
      date: '',
      printDate: '',
    }
  },

  created() {
    config()
    this.initCanteenList()
  },

  methods: {
    initTableList() {
      let data = {}
      data.canteenId = this.ruleForm.canteen
      data.beginDate = this.ruleForm.date ? this.ruleForm.date[0] : ''
      data.endDate = this.ruleForm.date ? this.ruleForm.date[1] : ''
      Purchase.getFoodAccountList(data).then(res => {
        if (res.success) {
          let arr = []
          let {canteenName, beginDate, endDate} = res.result
          this.warehouseName = canteenName
          this.date = `${beginDate} - ${endDate}`
          this.printDate = formatTimeToDate()
          res.result.supplierSubtotalList.map(i => {
            let obj = {}
            obj.id = i.id
            obj.sort = i.index
            obj.supplierName = i.supplierName
            obj.subtotal = i.subtotal
            let tableTitleList = []
            i.sevenDaysSubtotalList.map((v) => {
              let obj2 = {}
              let date = v.date ? v.date.slice(5): ''
              obj2.lable = date
              obj2.prop = date
              obj2.width = '88'
              tableTitleList.push(obj2)
              obj[date] = v.subtotal
            })
            arr.push(obj)
            this.tableTitleList = tableTitleList
          })
          this.tableData = arr
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    /* 食堂数据 */
    initCanteenList() {
      Canteen.getCanteenNoPageList().then(res => {
        if (res.success) {
          let arr = []
          res.result.map(i => {
            let obj = {}
            obj.id = i.id
            obj.name = i.name
            arr.push(obj)
          })
          this.canteenList = arr
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      })
    },
    
    /* 重置 */
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    /* 搜索 */
    search() {
      if (!this.ruleForm.canteen) return this.$message.error('请选择食堂')
      if (this.ruleForm.date.length == 0) return this.$message.error('请选择日期')
      let beginDate = this.ruleForm.date ? this.ruleForm.date[0] : ''
      let endDate = this.ruleForm.date ? this.ruleForm.date[1] : ''
      if (calculationDays(beginDate, endDate) > 7) return this.$message.error('日期最多展示7天')
      
      this.initTableList();
    },

    goBack() {
      this.$router.go(-1)
    },

    confirmPrint() {
      this.printerDialog = true
    },

    closePrinterDialog() {
      this.printerDialog = false
    },
  }
}
</script>

<style lang='scss'>
.foot-account {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: $bg-WhiteSmoke;
  .top-container {
    box-sizing: border-box;
    background: $bg-white;
    padding: 10px;
    .el-form-item__label {
      padding: 0;
    }
    .el-form-item {
      margin-bottom: 0px
    }
    .row {
      @include flex-start;
      flex-wrap: wrap;
      .btn {
        margin-left: 30px;
        .el-form-item__content {
          margin-left: 0px!important;
          display: flex;
        }
      }
    }
    .el-select {
      .el-input__prefix, .el-input__suffix {
        top: -3px;
      }
    }
  }
  .container {
    flex: 1;
    margin-top: 20px;
    padding: 20px 20px 80px 20px;
    box-sizing: border-box;
    background: $bg-white;
    position: relative;
    .foot {
      position: fixed;
      width: calc(100% - 242px);
      bottom: 0;
      left: 221px;
      z-index: 99;
    }
  }
  
  .nothing {
    position: absolute;
    left: 52%;
    top: 50%;
    transform: translate(-50%,-50%);
    img {
      width: 157px;
      height: 157px;
    }
    p {
      font-size: $fs-small-l;
      font-weight: 400;
      color: $color-LightGrey;
      margin-top: 24px;
    }
  }

  .el-dialog__header,
  .el-dialog__footer {
    border: none;
  }
  .el-dialog__body {
    padding: 0px 20px
  }
  .el-dialog__body  .el-table__body-wrapper.is-scrolling-none {
    max-height: 261px!important;
    overflow-y: auto;
  }
  .el-table .cell, .el-table--border td:first-child .cell, .el-table--border th:first-child .cell {
    padding-left: 16px;
  }
  
  .el-table__header-wrapper {
    background: $bg-table;
    .el-table__header {
      tr {
        th {
          background: $bg-table;
          padding: 0;
          height: 44px;
          .cell {
            color: $color-BlackGrey;
            line-height: 16px;
            padding: 8px 16px;
            font-size: $fs-small-l;
          }
        }
      }
    }
  }
  .el-table__footer-wrapper {
    tbody td {
      background: $bg-white;
      border-bottom: 0; 
    }
  }
  .el-dialog__footer {
    @include flex-end;
  }
  .printer-dialog {
    .el-dialog {
      width: 1088px!important;
    }
  }
  .printer-dialog .footer {
    height: 80px;
    line-height: 80px;
    text-align: right;
  }
  
  .el-dialog__footer {
    .dialog-footer {
      width: 100%;
      @include flex-between;
    }
  }
  
  .sign-container {
    width: auto!important;
    justify-content: flex-start!important;
    position: absolute;
    z-index: 111;
  }
  .under-line {
    width: 150px!important;
  }
  .sign-content {
    margin-right: 60px;
  }
  .printer-dialog .el-table__footer-wrapper {
    font-size: 16px;
    font-weight: bold;
    color: #333333;
  }
}
</style>


<style midia="print">
#printer .printer-title {
  height: 64px;
  font-size: 24px;
  line-height: 64px;
  text-align: center;
  margin-bottom: 20px;
}
#printer .printer-message {
  width: 100%;
}
#printer .printer-message .list {
  display: flex;
  justify-content: space-between;
}
#printer .printer-message .list .list-item {
  font-size: 12px;
  padding-bottom: 16px;
  text-align: left;
}
#printer .table .el-table {
  border: 1px solid #000;
}
#printer .el-table th.is-leaf {
  border-bottom: 1px solid #000;
}
#printer .table .el-table td {
  border-bottom: 1px solid #000;
}
#printer .el-table__footer-wrapper td {
  border-top: 1px solid #000;
}
#printer .table .el-table .el-table__body-wrapper .el-table__body tr td .cell {
  height: auto;
  line-height: 20px;
  font-size: 12px;
}
#printer .table th {
  width: 60px;
}
#printer .sign-container {
  width: 100%;
  margin-top: 30px;
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  display: flex;
  justify-content: space-between;
}
#printer .under-line {
  display: inline-block;
  width: 100px;
  border-bottom: 1px solid #000;
}
</style>